import AnnotationCollection from './AnnotationCollection';

export {
    AnnotationCollection
};



// WEBPACK FOOTER //
// ./plugins/large_image/web_client/collections/index.js